<template>
  <main class="edit-role">
    <el-dialog :title="title" :visible.sync="auth.isShowDialog" width="574px">
      <roleCommon
        ref="role"
        :showCheckBox="showCheckBox"
        :type="type"
        :role="role"
      />
      <span slot="footer" class="dialog-footer" v-if="type === 'edit'">
        <el-button @click="goBack">返回</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </main>
</template>

<script>
import roleCommon from './role-common.vue'
import { mapState } from 'vuex'
export default {
  created() {},
  components: {
    roleCommon,
  },
  data() {
    return {}
  },
  props: {
    expandAll: {
      type: Boolean,
    },
    showCheckBox: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    title: {
      type: String,
    },
    role: {
      type: Object,
    },
  },
  computed: {
    auth() {
      return this.$store.state.auth
    },
  },
  methods: {
    save() {
      this.$refs.role.submitForm()
    },
    goBack() {
      this.$store.commit('auth/update', {
        isShowDialog: false,
      })
    },
  },
}
</script>

<style lang="stylus">
.edit-role
  .el-dialog
    .el-dialog__footer
      margin-top 32px
</style>
